const NS = 'composerDraft:v1';

const k = (key: string) => `${NS}:${key}`;

export type StoredDraft = {
  text: string;
  updatedAt: number;
};

export const composerDraftStorage = {
  read(key: string): StoredDraft | null {
    try {
      const raw = localStorage.getItem(k(key));
      if (!raw) return null;
      const parsed = JSON.parse(raw) as StoredDraft;
      if (typeof parsed?.text !== 'string') return null;
      if (typeof parsed?.updatedAt !== 'number') return null;
      return parsed;
    } catch {
      return null;
    }
  },

  write(key: string, value: StoredDraft) {
    localStorage.setItem(k(key), JSON.stringify(value));
  },

  clear(key: string) {
    localStorage.removeItem(k(key));
  },
};
